<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            シナリオのパーツセット化
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-primary" has-icon>
              「{{selectScenarioBotName}}」のパーツセット化を実行します。<br>
              パーツセット名、作成者を記入し、保存してください。<br>
              ※シナリオに含まれるStartに戻るパーツとパーツセットは除外されます。
            </b-message>
          </p>
          <hr>
          <p style="padding-bottom: 0.5em;"><b>パーツセット名</b></p>
          <b-input v-model="roboPartsSetName"></b-input>
          <p style="padding-bottom: 0.5em;padding-top: 0.5em;"><b>作成者</b></p>
          <b-input v-model="author"></b-input>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive = false">閉じる</a>
          <a class="card-footer-item" @click="clickExportRoboPartsSet()">保存</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalExportListScenario',
  data () {
    return {
      isCardModalActive: false,
      roboPartsSetName: '',
      author: ''
    }
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'isModalExportListScenario', 'selectScenarioBotName']),
    ...mapState('auth', ['user'])
  },
  watch: {
    isModalExportListScenario () {
      this.isCardModalActive = this.isModalExportListScenario
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    }
  },
  methods: {
    clickExportRoboPartsSet () {
      if (!this.roboPartsSetName) {
        alert('パーツセット名が入力されていません。')
        return
      }
      if (!this.author) {
        alert('作成者が入力されていません。')
        return
      }

      const exportData = {
        parts_set_name: this.roboPartsSetName,
        author: this.author,
        company: this.user.companyPK,
        scenario_table: this.scenarioTable
      }
      this.$store.dispatch('chatbot/clickExportRoboPartsSet', exportData)
      this.$store.dispatch('chatbot/closeModalScenario')
      this.isCardModalActive = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalExportListScenario.vue